module.exports = __webpack_public_path__ + "static/media/bendystav.2aced0b7.svg";